import { StepProps } from '../TimsurveyWizard'
import { EsitoTimsurvey, UscitaVuotoMotivoTimsurvey } from '../../../types/timsurvey'

const ESITI: { value: EsitoTimsurvey; label: string }[] = [
  { value: 'SURVEY_ESEGUITA', label: 'Survey eseguita' },
  { value: 'SURVEY_ESEGUITA_CON_ESIGENZA_LAN', label: 'Survey eseguita con esigenza LAN' },
  { value: 'USCITA_A_VUOTO', label: 'Uscita a vuoto' },
]

const MOTIVI: { value: UscitaVuotoMotivoTimsurvey; label: string }[] = [
  { value: 'RIPENSAMENTO_CLIENTE', label: 'Ripensamento cliente' },
  { value: 'ALTRO', label: 'Altro' },
]

export default function StepEsito({ form, setForm, onNext, onBack, isFirstStep }: StepProps) {
  const puoAvanzare =
    !!form.esito &&
    (form.esito !== 'USCITA_A_VUOTO' ||
      (!!form.uscita_vuoto_motivo &&
        (form.uscita_vuoto_motivo !== 'ALTRO' || !!form.uscita_vuoto_altro_descrizione.trim())))

  return (
    <div className="card p-4 space-y-3">
      <div className="grid grid-cols-1 gap-3">
        {ESITI.map(e => (
          <button
            key={e.value}
            className="text-left p-4 rounded-lg border-2 transition"
            style={{
              borderColor: form.esito === e.value ? '#1E40AF' : '#e5e7eb',
              background: form.esito === e.value ? 'rgba(30,64,175,.06)' : '#fff',
            }}
            onClick={() => setForm(f => ({ ...f, esito: e.value }))}
          >
            <span className="font-medium">{e.label}</span>
          </button>
        ))}
      </div>

      {form.esito === 'USCITA_A_VUOTO' && (
        <div className="space-y-3">
          <div>
            <label className="label">Motivo</label>
            <select
              className="select w-full"
              value={form.uscita_vuoto_motivo ?? ''}
              onChange={e => setForm(f => ({ ...f, uscita_vuoto_motivo: e.target.value as UscitaVuotoMotivoTimsurvey }))}
            >
              <option value="">Seleziona motivo...</option>
              {MOTIVI.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
          </div>
          {form.uscita_vuoto_motivo === 'ALTRO' && (
            <div>
              <label className="label">Descrizione</label>
              <textarea
                className="input w-full"
                rows={3}
                value={form.uscita_vuoto_altro_descrizione}
                onChange={e => setForm(f => ({ ...f, uscita_vuoto_altro_descrizione: e.target.value }))}
              />
            </div>
          )}
        </div>
      )}

      <div className="flex gap-2">
        {!isFirstStep && <button className="btn-secondary" onClick={onBack}>Indietro</button>}
        <button className="btn-primary flex-1" disabled={!puoAvanzare} onClick={onNext}>Avanti</button>
      </div>
    </div>
  )
}
